import { useWeb3WithDefault } from './useWeb3WithDefault';
import { chainLookupTable } from '../config/chains';

function useIsChainValid(path: string): boolean {
    const { chainId } = useWeb3WithDefault();
    return Object.keys(chainLookupTable[path]).includes(String(chainId));
}

export default useIsChainValid;
